var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.categoryTree != null
    ? _c(
        "span",
        _vm._l(_vm.categories, function (c) {
          return _c(
            "a",
            {
              key: c.id,
              staticClass: "badge badge-pill bg-light me-1",
              staticStyle: { "text-decoration": "none" },
              attrs: { href: "" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.$emit("pill-clicked", _vm.findNodeById(c.id))
                },
              },
            },
            [_vm._v("\n      " + _vm._s(c.name) + "\n  ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }